module.exports = __webpack_public_path__ + "img/intro_mock.5386b066.png";